const API='https://api.dawwin.al-ilm.net/connected-learning/records'
export type ConnectedCategory='subject-association'|'lesson-connection'|'lesson-dismissal'|'concept-accepted'|'concept-relationship'|'analysis-cache'|'analysis-dismissal'
export type ConnectedRecord={category:ConnectedCategory;record_key:string;payload:unknown;updated_at:string}
async function request<T>(path:string,init:RequestInit={}) {
 const response=await fetch(API+path,{...init,credentials:'include',headers:{'Content-Type':'application/json',Accept:'application/json',...init.headers}})
 if(!response.ok)throw new Error((await response.json().catch(()=>null))?.error||'connected_learning_http_'+response.status)
 return (response.status===204?null:await response.json()) as T
}
export async function listConnected(category?:ConnectedCategory) {
 return (await request<{records:ConnectedRecord[]}>(category?'?category='+encodeURIComponent(category):'')).records
}
export async function putConnected(category:ConnectedCategory,key:string,payload:unknown) {
 return request('/'+category+'/'+encodeURIComponent(key),{method:'PUT',body:JSON.stringify({payload})})
}
export async function importConnected(category:ConnectedCategory,key:string,payload:unknown) {
 return request('/'+category+'/'+encodeURIComponent(key)+'?import=1',{method:'PUT',body:JSON.stringify({payload})})
}
export function isDeleted(record:ConnectedRecord){return !!record.payload && typeof record.payload==='object' && (record.payload as {deleted?:boolean}).deleted===true}
export async function removeConnected(category:ConnectedCategory,key:string) {
 return request('/'+category+'/'+encodeURIComponent(key),{method:'DELETE'})
}
export function lessonPairKey(first:string,second:string){return [first,second].sort().join(':')}
export function normalizedConceptKey(subject:string,term:string) {
 return subject.toLowerCase().trim()+':'+term.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s+/g,' ').trim()
}
